import { useState, useEffect } from "react";
import { bfs } from "./decisionTree";

const RightSection = (props) => {
  const { handleSelectResult, selectState, filtersApplied, applyState } = props;
  const [filters, setFilters] = useState(filtersApplied);
  const [ResultData, setResultData] = useState();
  const [resultLength, setResultLength] = useState();
  const [resultLengthArabic, setResultLengthArabic] = useState();

  //prettier-ignore
  const arabicNumerals = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩", "١٠", "١١", "١٢", "١٣", "١٤", "١٥", "١٦", "١٧", "١٨", "١٩", "٢٠", "٢١", "٢٢", "٢٣", "٢٤", "٢٥", "٢٦", "٢٧", "٢٨", "٢٩", "٣٠", "٣١", "٣٢", "٣٣", "٣٤"]

  const handleResults = () => {
    let treeResult = bfs(filters);
    setResultData(treeResult);
    setResultLength(treeResult.length);
    setResultLengthArabic(arabicNumerals[treeResult.length]);
  };

  useEffect(() => {
    handleResults();
  }, [applyState]);

  return (
    <div className="right-section">
      <div className="results">
        <span className="results-eng">{resultLength} results • </span>
        <span className="results-arab">{resultLengthArabic}&nbsp; نتائج </span>
        <hr />
      </div>
      <div className="results-data">
        {ResultData?.map((result, id) => (
          <div key={id + 1}>
            <div
              className="results-data-images"
              onClick={() => {
                handleSelectResult(
                  !selectState,
                  result.image,
                  result.resultEngText,
                  result.resultArabText,
                  id + 1,
                  result.pdfID,
                  result.previewImage
                );
              }}
            >
              <div style={{ display: "grid", width: "18%" }}>
                <span className="results-data-images-number">{id + 1}</span>
              </div>
              <div className="results-data-images-image">{result.image}</div>
              <div className="results-data-images-text">
                <img
                  src="/icons/red_arrow.svg"
                  className="results-data-images-text-next-arrow"
                  alt="Next"
                />
              </div>
            </div>
            <hr />
          </div>
        ))}
      </div>
    </div>
  );
};

export default RightSection;
